<template>
  <div class="login-wrp">
    <header>
      <i class="basicmobilefont">&#xe6b7;</i>
    </header>
    <section>
      <div style="margin-top: 2.39rem" class="ipt-wrp">
        <i class="basicmobilefont">&#xe6ab;</i>
        <input type="tel" v-model="editData.tel" placeholder="请输入手机号" />
        <van-button loading-type="spinner" style="opacity: 0" class="verify-btn" type="info">发送验证码</van-button>
      </div>
      <div style="margin-top: 1.75rem" class="ipt-wrp">
        <i class="basicmobilefont">&#xe6ae;</i>
        <input type="tel" maxlength="6" v-model="editData.checkCode" placeholder="请输入验证码" />
        <span></span>
        <van-button v-show="!verifyCountdownVisible" v-tap="{methods: sendCode}" class="verify-btn" type="info">发送验证码</van-button>
        <van-button v-show="verifyCountdownVisible" class="verify-btn" type="info">{{verifyCountdown}}s</van-button>
      </div>
      <van-button loading-type="spinner" class="submit-btn" :loading="submitLoading" type="info" @click='checkAuthCode'>登录</van-button>
      <!-- <div class="user-protocol">
        <van-checkbox v-model="protocolCheck" class="user-protocol-check" :style="{border: protocolCheck ? '1px solid #fff' : ''}" checked-color="transparent" icon-size="12px" shape="square" />
        <span>我已阅读并同意</span>
        <a>用户协议</a>
      </div> -->
    </section>
  </div>
</template>

<script>
import {
  CellGroup,
  Field,
  Button,
  Notify,
  Checkbox
} from 'vant'
import { localStorage, isMobileNo } from '@utils/basicUtil'
import { officialAccountRequest } from '@services'

export default {
  data () {
    return {
      editData: {
        tel: '',
        checkCode: ''
      },
      submitLoading: false,
      protocolCheck: false,
      verifyCountdown: 60,
      verifyCountdownVisible: false
    }
  },
  mounted () {
    this.checkLogin()
  },
  methods: {
    async sendCode () {
      if (!isMobileNo(this.editData.tel)) {
        return Notify({ type: 'danger', message: '请输入正确的手机号' })
      }

      const data = await officialAccountRequest.weChat.sendCode({ tel: this.editData.tel })
      if (!data.success) {
        return Notify({ type: 'danger', message: data.message })
      }

      this.countdownHandle()
    },
    async checkAuthCode () {
      if (!isMobileNo(this.editData.tel)) {
        return Notify({ type: 'danger', message: '请输入正确的手机号' })
      }
      if (!this.editData.checkCode.length) {
        return Notify({ type: 'danger', message: '请输入验证码' })
      }

      const data = await officialAccountRequest.weChat.checkAuthCode(this.editData)

      if (data.success) {
        if (data.result) {
          let user = data.result
          this.$store.commit('officialAccount/changeUserInfo', user)
          localStorage.set('user', JSON.stringify(user))
          localStorage.set('login', 1)
          this.$router.push('/official-account/manager')
        } else {
          return Notify({ type: 'danger', message: '验证码无效或已过期！' })
        }
      }
    },
    checkLogin () {
      if (localStorage.get('login')) {
        this.$store.commit('officialAccount/changeUserInfo', JSON.parse(localStorage.get('user')))
        this.$router.push('/official-account/manager')
      } else {
        this.$router.push('/official-account/login')
      }
    },
    countdownHandle () {
      if (this.verifyCountdown > 0) {
        this.verifyCountdownVisible = true
        this.verifyCountdown--
        setTimeout(() => {
          this.countdownHandle()
        }, 1000)
      } else {
        this.verifyCountdownVisible = false
        this.verifyCountdown = 60
      }
    }
  },
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox
  }
}
</script>

<style lang="less" scoped>
  .login-wrp {
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/bg.jpg);
    background-size: cover;
    overflow: hidden;
    header {
      width: 80%;
      height: 115px;
      margin:0 auto;
      margin-top: 144px;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #fff;
      i {
        font-size: 60px;
      }
    }
    section {
      width: 80%;
      margin: 0 auto;
      overflow: visible;
      .submit-btn {
        height: 79px;
        width: 100%;
        margin-top: 100px;
        font-size: 32px;
        font-weight: 500;
        color: #2196F3;
        background:#fff;
        box-shadow:0px 4px 18px 3px rgba(0,160,233,0.11);
        letter-spacing: 20px;
      }
      .ipt-wrp {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #fff;
        padding-bottom: 18px;
        font-size: 30px;
        i {
          width: 32px;
          height: auto;
          margin-right: 32px;
          color: #fff;
        }
        input {
          border: none;
          font-size:30px;
          font-weight:bold;
          color:#fff;
          width: 300px;
          background-color: transparent;
          vertical-align: middle;
          font-family: 'PingFang-SC-Regular';
          font-weight: 400;
          &::-webkit-input-placeholder {
            font-weight: 400;
            color: #fff;
            font-family: 'PingFang-SC-Regular';
            font-weight:400;
          }
        }
        .verify-btn {
          height: 100%;
          font-size: 22px;
          font-family: 'PingFang SC';
          font-weight: 400;
          color:rgba(33,150,243,1);
          background-color: #fff;
          text-align: center;
        }
      }
      .user-protocol {
        height: 23px;
        font-size: 24px;
        font-family: 'PingFang SC';
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 100px;
        width: 350px;
        border-color: #fff;
        span {
          font-weight: 400;
          color: rgba(255,255,255,1);
          opacity: 0.5;
        }
        a {
          font-size:24px;
          font-weight:400;
          text-decoration: underline;
          color:rgba(255,255,255,1);
          opacity:0.8;
        }
        .user-protocol-check {
          border-color: #fff !important;
          .van-checkbox__icon {
            .van-icon {
              border: none !important;
            }
          }
        }
      }
    }
  }
</style>
